import { Button } from '@capturi/ui-components'
import { BaseModalComponentProps } from '@capturi/use-modal'
import {
  Box,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  useToast,
} from '@chakra-ui/react'
import { Trans, t } from '@lingui/macro'

import { FC, useState } from 'react'
import { useCreateToken } from '../api/useOrganizationSettings'

type Props = { organizationUid: string }

export const TokenModal: FC<Props & BaseModalComponentProps> = ({
  onClose,
  organizationUid,
}) => {
  const { mutate: createToken, isPending } = useCreateToken(organizationUid)
  const [title, setTitle] = useState('')
  const [token, setToken] = useState('')
  const toast = useToast()

  const handleCreateToken = () => {
    createToken(
      { title },
      {
        onSuccess: (newToken) => {
          toast({
            title: 'Token created',
            status: 'success',
          })
          setToken(newToken.token)
        },
        onError: (error) => {
          toast({
            title: 'Error creating token',
            description: error.message,
            status: 'error',
          })
        },
      },
    )
  }

  const handleCopyToken = () => {
    navigator.clipboard.writeText(token)
    toast({
      title: 'Token copied to clipboard',
      status: 'info',
    })
  }
  return (
    <Modal size="2xl" isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>
          <Trans>Add token</Trans>
        </ModalHeader>
        <ModalBody>
          <VStack gap={5}>
            <Box w="100%">
              <Heading size="md">
                <Trans>Token name</Trans>
              </Heading>
              <Input
                isDisabled={!!token || isPending}
                onChange={(e) => setTitle(e.target.value)}
                placeholder={t`Token name`}
              />
            </Box>

            {token && (
              <Box w="100%">
                <Box>
                  <Text fontWeight="bold">
                    <Trans>Token is only visible once!</Trans>
                  </Text>
                  <Text
                    mt="2"
                    p="2"
                    bg="gray.100"
                    borderRadius="md"
                    userSelect="all"
                    fontFamily="mono"
                  >
                    {token}
                  </Text>
                </Box>
              </Box>
            )}
          </VStack>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button onClick={onClose} isDisabled={isPending}>
            <Trans>Cancel</Trans>
          </Button>
          {!token ? (
            <Button
              primary
              isLoading={isPending}
              onClick={() => {
                handleCreateToken()
              }}
            >
              <Trans>Create token</Trans>
            </Button>
          ) : (
            <Button variant="ghost" primary onClick={handleCopyToken}>
              <Trans>Copy</Trans>
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
